// extracted by mini-css-extract-plugin
export default {"root":"FormError_root__0tW7J t-8 b-8","intro":"FormError_intro__oirSJ"};